module.exports = __webpack_public_path__ + "static/media/microsoft-word-logo.cc4548fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/microsoft-word-logo.png
// module id = 221
// module chunks = 0